// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

orderStatusFormStyles.submitButton = {
    css: css`
        margin-top: 12px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

orderStatusFormStyles.submitButtonGridItem = {
    width: [12, 12, 12, 3, 3],
};

orderStatusFormStyles.orderNumberGridItem = orderStatusFormStyles.emailOrPostalCodeGridItem = {
    width: [12, 12, 12, 3, 3],
    css: css`
        @media print {
            width: 50%;
        }
    `,
};
